import { useMutation } from '@tanstack/react-query';
import { requestAndPrintPacket } from '../../service/requestAndPrintPacket/apiService';
import { PacketRequestType } from '../../@types/PacketReqFormData.type';

const useRequestAndPrintPacket = () => {
  return useMutation({
    mutationFn: ({
      reqData,
      accessToken,
    }: {
      reqData: PacketRequestType;
      accessToken: string;
    }) => requestAndPrintPacket(reqData, accessToken),
    retry: 1,
  });
};

export default useRequestAndPrintPacket;
